import { Button, colors } from '@insurancemenu/imenu-components-lib';
import { boxShadows } from '@insurancemenu/imenu-components-lib/dist/utils';
import { scrollEffectStyle } from 'components/common/styles/verticalScrollEffect';
import styled from 'styled-components';

export const DropdownWrapperStyled = styled.div`
  position: relative;
`;

export const DropdownContentStyled = styled.div`
  position: absolute;
  background-color: ${colors.neutral.white};
  top: 6rem;
  left: 0;
  box-shadow: ${boxShadows.dark[4]};
  border-radius: 10px;
  min-width: 40rem;

  /* Required to keep content above other dropdowns when the action bar wraps */
  z-index: 1;
`;

export const DropdownHeaderStyled = styled.header`
  padding: 2.4rem 0 2rem;
  border-bottom: 0.1rem solid ${colors.neutral[300]};
`;

export const DropdownTitleStyled = styled.h3`
  font-size: 1.8rem;
  line-height: 2.8rem;
  text-align: center;
  margin: 0 0 0.5rem;
`;

export const DropdownSubtitleStyled = styled.p`
  text-align: center;
  color: ${colors.neutral[700]};
  font-size: 1.4rem;
  line-height: 2rem;
  padding: 0 7rem;
  margin: 0;
`;

export const ListWrapperStyled = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0 2rem 2rem;
  max-height: 35rem;
  overflow-y: auto;
  ${scrollEffectStyle()}
`;

export const ListItemStyled = styled.li`
  padding: 2rem 0;
  border-bottom: 0.1rem solid ${colors.neutral[300]};

  &:last-child {
    border-bottom: none;
  }
`;

export const ListItemHeaderSectionStyled = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 1.5rem;
`;

export const ListItemTitleStyled = styled.h4`
  color: ${colors.neutral[900]};
  font-size: 1.8rem;
  line-height: 2.8rem;
  letter-spacing: 0.02em;
  margin: 0;
`;

export const ListItemTextStyled = styled.p`
  background-color: rgb(162 179 222 / 10%);
  border-radius: 5px;
  font-size: 1.4rem;
  line-height: 2rem;
  letter-spacing: 0.02em;
  padding: 1rem 1.5rem;
  box-sizing: border-box;
  margin: 0;
`;

export const ActionButtonStyled = styled(Button)`
  width: 8.6rem;
  height: 2.8rem;
  font-size: 1.2rem;
  line-height: 1.8rem;
`;

export const DropdownFooterStyled = styled.footer`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem 0;
  margin: 0;
  border-top: 0.1rem solid ${colors.neutral[300]};
`;
